// export const API_URI = 'https://sukhvir0028.pythonanywhere.com'
// export const API_URI = 'http://156.67.82.131:8006';
export const API_URI = 'https://slo.xn--nted-gra.com';

export const SERVER_URL = 'ws://156.67.82.131:8067/ws/transcription/';
// export const API_URI = 'https://xn--nted-gra.com';
